import { render, staticRenderFns } from "./report_documents.vue?vue&type=template&id=042a1230&scoped=true"
import script from "./report_documents.vue?vue&type=script&lang=js"
export * from "./report_documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042a1230",
  null
  
)

export default component.exports